import { getDocumentWidth } from './util';
export const ZERO = 0;
export const ONE = 1;
export const TITLE = '力迅·西关雅筑';   // 微信的分享标题
export const DESC = '一条中山路，百年陈家祠';  // 微信的分享描述
export const NAME = '力迅·西关雅筑';  // 项目名字
export const PHONE = '020-88909999'; // 项目电话号码

export const LAT = 23.126014; // 经度
export const LON = 113.247821; // 纬度

export const isPc = getDocumentWidth();   // 判断可是浏览器宽度是不是大于677
